export var CommandSource;
(function (CommandSource) {
    CommandSource["FormSubmission"] = "FormSubmission";
    CommandSource["ManualEntry"] = "ManualEntry";
    CommandSource["Import"] = "Import";
    CommandSource["PublicApi"] = "PublicApi";
})(CommandSource || (CommandSource = {}));
export var CommandStatus;
(function (CommandStatus) {
    CommandStatus["Open"] = "open";
    CommandStatus["Submitted"] = "submitted";
    CommandStatus["Validated"] = "validated";
    CommandStatus["Complete"] = "complete";
    /** @deprecated - do not use anymore, manual command removed are fully deleted instead */
    CommandStatus["Archived"] = "archived";
    CommandStatus["Failed"] = "failed";
    CommandStatus["Expired"] = "expired";
})(CommandStatus || (CommandStatus = {}));
export var CommandLang;
(function (CommandLang) {
    CommandLang["EN"] = "EN";
    CommandLang["FR"] = "FR";
    CommandLang["ES"] = "ES";
    CommandLang["DE"] = "DE";
})(CommandLang || (CommandLang = {}));
export var CommandFormEmbedVersion;
(function (CommandFormEmbedVersion) {
    CommandFormEmbedVersion["EmbedV1"] = "EmbedV1";
    CommandFormEmbedVersion["EmbedV2"] = "EmbedV2";
})(CommandFormEmbedVersion || (CommandFormEmbedVersion = {}));
export var CommandAcquisitionSource;
(function (CommandAcquisitionSource) {
    CommandAcquisitionSource["OrganizationPage"] = "OrganizationPage";
})(CommandAcquisitionSource || (CommandAcquisitionSource = {}));
